module.exports = __webpack_public_path__ + "img/Location.0f1c46a2.svg";